import React, { useState } from 'react';
import {
  doc, getDoc, getFirestore, collection, addDoc,
  serverTimestamp, query, where, getDocs
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import {
  getStorage, ref, uploadString
} from 'firebase/storage';
import BackHomeButton from '../components/BackHomeButton';
import Get_Help from '../components/Get_Help';
import Help_Video from '../components/Help_Video';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import logo from '../New_Logo.png'; // Replace with actual logo path

import { functions,auth,db } from '../firebase'; // Ensure path is correct
import { httpsCallable } from 'firebase/functions';

function ComprehensionTool() {
  const [subject, setSubject] = useState('');
  const [Question, setQuestion] = useState('');
  const [aiResult, setAiResult] = useState('');
  const [message, setMessage] = useState('');
  const [standard, setStandard] = useState('unspecified');
  const [school, setSchool] = useState('unspecified');
  const [selectedLessonId, setSelectedLessonId] = useState('');

  const[textlanguage,setTextLanguage]= useState('');

  const [recentDownloads, setRecentDownloads] = useState([]);



  const [cooldown, setCooldown] = useState(0);
const [isCooldownActive, setIsCooldownActive] = useState(false);
const [language, setLanguage] = useState('');



  //const auth = getAuth();
  //const db = getFirestore();
  const storage = getStorage();
  const user = auth.currentUser;

  const location = useLocation();

  const [difficulty, setdifficulty] = useState('Hard');

  useEffect(() => {
  const fetchRecentDownloads = async () => {
    if (!school || !standard) return;

    //alert(school);
    //alert(standard);

    try {
      const q = query(
        collection(db, 'ai_comprehension_downloaded'),
        where('user_school', '==', school),
        where('user_standard', '==', standard)
      );

      const snapshot = await getDocs(q);    
      
      //alert(language);      

      const items = [];
      snapshot.docs
        .filter(doc => doc.data().text_language === language)// 🔥 language filter here
        .sort((a, b) => b.data().timestamp?.seconds - a.data().timestamp?.seconds)
        .forEach(doc => {
          const question = doc.data().Question;
          if (question && !items.some(item => item.question === question)) {
            items.push({
              label: `Comprehension ${items.length + 1}`,
              question
            });
          }
        });

      setRecentDownloads(items.slice(0, 10));

    } catch (err) {
      console.error('Error fetching recent downloads:', err);
    }
  };

  fetchRecentDownloads();
}, [school, standard, db,language]);

  
useEffect(() => {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes scrollLeft {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
  `;
  document.head.appendChild(style);
}, []);
  
async function fetchAIResponse(prompt) {

  const callGemini = httpsCallable(functions, 'callGemini');

  // 2. Try Gemini as fallback
  try {
    const result = await callGemini({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      generationConfig: {
        maxOutputTokens: 8192,
        temperature: 0.7
      }
    });

    // 🛡️ Secure Note: The App Check token was sent automatically!
    // result.data contains the body of the response from your backend
    return result.data.candidates?.[0]?.content?.parts?.[0]?.text;

  } catch (err) {
    console.error('Gemini error:', err.message);
    
    // Check for specific security failures
    if (err.code === 'failed-precondition') {
      alert("Security Check Failed: Please refresh the page.");
    }
  }

  // If both fail
  alert("Oops All AI engines are busy for now .Please try in a couple of minutes.");
  return null;
}

  const [subjectList, setSubjectList] = useState([]);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        if (!standard) return; // Don't fetch unless we have the user's standard

        const q = query(collection(db, 'Standard_Subject_Topic_Master'), where('Standard', '==', parseInt(standard)));
        const snapshot = await getDocs(q);
        const subjectsData = snapshot.docs.map(doc => doc.data().Subject);
        // Deduplicate and sort
        const uniqueSortedSubjects = [...new Set(subjectsData)].sort();

        setSubjectList(uniqueSortedSubjects);
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    };

    fetchSubjects();
  }, [standard]);

// countdown effect
useEffect(() => {
  let timer;
  if (isCooldownActive && cooldown > 0) {
    timer = setInterval(() => {
      setCooldown(prev => prev - 1);
    }, 1000);
  } else if (cooldown === 0) {
    setIsCooldownActive(false);
  }
  return () => clearInterval(timer);
}, [cooldown, isCooldownActive]);
  
  useEffect(() => {
    const state = location.state;
    if (state) {
      if (state.subject) setSubject(state.subject);
    }
  }, [location.state]);

  useEffect(() => {
  const fetchProfile = async () => {
    if (!user) return;

    try {
      const profileRef = doc(db, 'profiles', user.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
        setSchool(profileData.school || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }
  };

  fetchProfile();
}, [user,standard,db]);


  const handleGenerate = async () => {
    try {
      const profileRef = doc(db, 'profiles', user?.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }

    //alert(language); 

    if (language === "Select Language" || language === "") {
      alert('Please select language');
      return;
    }

    setTextLanguage(language);

    let prompt = `You are a teacher of a student of standard ${standard}. 
    The student needs to be given a 500 word comprehension . 
    The difficulty level of the comprehension and following questions should be ${difficulty}. 
    follow it up with 5 short answer questions based on the passage.
    Leave space below each question for children to write the answer.
    This should be followed by 5 choose the correct option kind of question and 5 fill in the blanks
    kind of questions.
    Then give 1 question each to write down 2 Nouns, 2 Pronouns  from the passage.
    Then give 2 words from passage for which we need to write antonyms.
    Then give 3 questions of true and false types.
    Do not give any suggestions or foul language in your response
    Give all Answers below all the questions.\n`;

    if(language === "Hindi")
    {
    prompt += `give sentences in Devnagari script only`;
    }

    if(language === "English")
    {
    prompt += `give sentences in English only`;
    }


    if(language === "Telugu")
    {
    prompt += `give sentences in Telugu script only`;
    }

    if(language === "Tamil")
    {
    prompt += `give sentences in Tamil script only`;
    }

    if(language === "Kannada")
    {
    prompt += `give sentences in Kannada script only`;
    }

    setMessage(`Generating Comprehension Worksheet...`);    

    try {

      const content = await fetchAIResponse(prompt);

      if (!content) {
        alert('Failed to generate response from AI.');
        setMessage('AI did not return a response.');
        return;
      }

      setAiResult(content);

      const docRef = await addDoc(collection(db, 'ai_checked_answers'), {
        userId: user?.uid || 'anonymous',
        subject:language,
        Question:content,
        Answer:'Comprehension',
        content:'Text',
        timestamp: serverTimestamp()
      });

      const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
      await uploadString(storageRef, content);

      
      setMessage(`Comprehension Generation successful for ${language} language`);      
      setLanguage('')

      setCooldown(600); // 10 minutes = 600 seconds
      setIsCooldownActive(true);
      
    } catch (err) {
      console.error(err);
      alert('Something went wrong: ' + err.message);
      setMessage('Failed to Check. Please try again.');
    }
  };

    const generatePdfBlob = async () => {
    return new Promise((resolve, reject) => {

      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      wrapper.style.fontFamily = 'Arial, sans-serif';
      wrapper.style.whiteSpace = 'pre-wrap';
      wrapper.style.padding = '40px 40px 40px 40px'; // top, right, bottom, left;
      wrapper.style.width = '90%';

      // Add image
      const placeholderImage = document.createElement('img');
      placeholderImage.src = logo; // <-- replace with actual URL or base64
      placeholderImage.style.display = 'block';
      placeholderImage.style.margin = '0 auto'; // center
      placeholderImage.style.width = '150px';   // adjust size
      placeholderImage.style.height = 'auto';
      wrapper.appendChild(placeholderImage);

      // Add placeholder (first half of first page)
      const placeholder = document.createElement('div');
      placeholder.innerText = 'Eascode';
      placeholder.style.fontSize = '48px';
      placeholder.style.fontWeight = 'bold';
      placeholder.style.textAlign = 'center';
      placeholder.style.marginTop = '10px';
      placeholder.style.marginBottom = '10px';
      wrapper.appendChild(placeholder);

      const placeholder_value = document.createElement('div');
      placeholder_value.innerText = 'For Parents by Parents';
      placeholder_value.style.fontSize = '24px';
      placeholder_value.style.fontWeight = 'bold';
      placeholder_value.style.textAlign = 'center';
      placeholder_value.style.marginTop = '10px';
      placeholder_value.style.marginBottom = '10px';
      wrapper.appendChild(placeholder_value);

    // Add label before URL
    const toolUrlLabel = document.createElement('div');
    toolUrlLabel.innerText = 'For more worksheets based on your school syllabus and pattern visit : :'; 
    toolUrlLabel.style.fontSize = '16px';
    toolUrlLabel.style.fontWeight = 'bold';
    toolUrlLabel.style.textAlign = 'center';
    toolUrlLabel.style.marginBottom = '5px';
    wrapper.appendChild(toolUrlLabel);

    // Add tool URL (clickable)
    const toolUrl = document.createElement('a');
    toolUrl.href = 'https://eascode.web.app/login'; // <-- replace with your tool URL
    toolUrl.innerText = 'https://eascode.web.app/login';
    toolUrl.style.fontSize = '16px';
    toolUrl.style.color = 'blue';
    toolUrl.style.textAlign = 'center';
    toolUrl.style.display = 'block';
    toolUrl.style.marginBottom = '50px';
    toolUrl.style.textDecoration = 'underline';
    wrapper.appendChild(toolUrl);

      // Actual AI result after placeholder
      const content = document.createElement('div');
      content.innerText = aiResult;
      wrapper.appendChild(content);

      //wrapper.innerText = aiResult;
  
      const watermark = document.createElement('div');
      watermark.innerText = 'Eascode';
      watermark.style.position = 'fixed';
      watermark.style.top = '50%';
      watermark.style.left = '50%';
      watermark.style.transform = 'translate(-50%, -50%) rotate(-30deg)';
      watermark.style.fontSize = '120px';
      watermark.style.color = 'rgba(0, 0, 0, 0.05)';
      watermark.style.zIndex = '0';
      watermark.style.pointerEvents = 'none';
      watermark.style.userSelect = 'none';
      watermark.style.width = '100%';
      watermark.style.textAlign = 'center';
      wrapper.appendChild(watermark);

      // Add legal terms (last page footer)
    const legalTerms = document.createElement('div');
    legalTerms.innerText = 
      'Terms & Conditions:\n\n' +
  'This document is provided for personal use only. Unauthorized copying, ' +
  'reproduction, distribution, or modification of any part of this content is strictly prohibited. ' +
  'No portion of this material may be stored in a retrieval system, transmitted, or otherwise ' +
  'used in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise— ' +
  'without the prior written permission of Eascode. All intellectual property rights, including ' +
  'but not limited to copyrights, trademarks, and design rights, are fully reserved.\n\n' +
  '© Eascode Pvt. Ltd.' + new Date().getFullYear()+ 
  '. \n All rights reserved. Unauthorized use of this document or its contents may result in ' +
  'civil and/or criminal liability under applicable laws.\n\n' +
  'By using, viewing, or distributing this document, you expressly agree to comply with these terms.';

    legalTerms.style.fontSize = '12px';
    legalTerms.style.color = '#444';
    legalTerms.style.textAlign = 'justify';
    legalTerms.style.marginTop = '100px';
    legalTerms.style.padding = '20px 40px';
    wrapper.appendChild(legalTerms);
  
      document.body.appendChild(wrapper);
  
      const opt = {
        margin: 0.5,
        filename: 'temp.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };
  
      html2pdf().set(opt).from(wrapper).outputPdf('blob').then((blob) => {
        document.body.removeChild(wrapper);
        resolve(blob);
      }).catch((err) => {
        document.body.removeChild(wrapper);
        reject(err);
      });




    });
  };
  
  
    const handleDownload = async () => {
    const blob = await generatePdfBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Eascode_AI_Comprehension_worksheet.pdf`;
    a.click();
    URL.revokeObjectURL(url);

      const docRef = await addDoc(collection(db, 'ai_comprehension_downloaded'), {
        userId: user?.uid || 'anonymous',
        subject:language,
        Question:aiResult,
        Answer:'Comprehension',
        content:'Text',
        timestamp: serverTimestamp(),
        user_school:school,
        user_standard:standard,
        text_language:textlanguage,
      });
  };

return (
    <>
      {/* 🔹 Inject Keyframes for animations */}
      <style>{`
        @keyframes scrollLeft {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>

      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-2 sm:py-6 px-2 sm:px-6 lg:px-8 font-sans">
        
        {/* Full width container mirroring our design system */}
        <div className="w-full mx-auto bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-3 sm:p-8 relative overflow-hidden">
          
          {/* Top Nav & Header - Balanced Flex Layout */}
          <div className="flex items-center justify-between mb-2 sm:mb-4 w-full gap-2">
            <div className="flex-1 flex justify-start min-w-0">
              <BackHomeButton
                backState={{ selectedLessonId, subject }}
              />
            </div>
            <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
              <h2 className="text-sm sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-nowrap">
                Comprehension <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Tool</span>
              </h2>
            </div>
            <div className="flex-1 flex justify-end min-w-0"><Get_Help/></div>
          </div>

          <div className="text-center mb-4 sm:mb-8">
            <p className="text-[10px] sm:text-sm text-slate-500 font-medium w-full mx-auto px-2">
              This tool will help you create a comprehension passage and worksheet questions as per your standard.
            </p>
          </div>

          {/* Drop your reusable component here */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
            <Help_Video 
              videoId="8zAO_HCfU-4" /* ⚠️ Replace with actual YouTube ID */
              title="How to use Voice to Text" 
            />
          </div>

          <br></br>

          {/* Trending Downloads */}
          {recentDownloads.length > 0 && (
            <div className="mb-4 sm:mb-8 bg-slate-50 border border-slate-200 rounded-lg sm:rounded-xl p-2 sm:p-4 shadow-sm max-w-4xl mx-auto">
              <div className="flex items-center gap-2 mb-2 sm:mb-3 text-[9px] sm:text-xs font-bold text-slate-500 uppercase tracking-widest">
                <span className="flex h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-orange-500 animate-pulse"></span>
                Recently downloaded in your school
              </div>
              <div className="overflow-hidden w-full mask-linear-gradient">
                <div 
                  className="flex gap-2 w-max hover:[animation-play-state:paused]"
                  style={{ animation: 'scrollLeft 25s linear infinite' }}
                >
                  {(recentDownloads.length > 1 ? [...recentDownloads, ...recentDownloads] : recentDownloads).map((item, index) => (
                    <span
                      key={index}
                      className="bg-white border border-slate-200 hover:border-indigo-400 hover:text-indigo-600 transition-colors px-2 py-1 sm:px-4 sm:py-2 rounded-full text-[10px] sm:text-sm font-semibold text-slate-600 shadow-sm cursor-pointer whitespace-nowrap"
                      onClick={() => setAiResult(item.question)}
                      title={item.question}
                    >
                      🔥 {item.label}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Configuration Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-8 max-w-4xl mx-auto">
            
            {/* Language Dropdown */}
            <div className="space-y-1 sm:space-y-2">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Language</label>
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
              >
                <option value="Select Language">Select Language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Kannada">Kannada</option>
              </select>
            </div>

            {/* Difficulty Dropdown (Color-coded) */}
            {language && language !== "Select Language" && (
              <div className="space-y-1 sm:space-y-2 animate-in fade-in zoom-in-95 duration-200">
                <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1 flex items-baseline gap-1 sm:gap-2">
                  Difficulty Level
                </label>
                <select
                  value={difficulty}
                  onChange={(e) => setdifficulty(e.target.value)}
                  required
                  className={`w-full border-2 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 text-[11px] sm:text-base font-bold transition-all outline-none cursor-pointer appearance-none
                    ${difficulty === 'Easy' ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 
                      difficulty === 'Medium' ? 'bg-amber-50 border-amber-200 text-amber-800' : 
                      'bg-rose-50 border-rose-200 text-rose-800'}`}
                >
                  <option value="Easy">🟢 Easy</option>
                  <option value="Medium">🟡 Medium</option>
                  <option value="Hard">🔴 Hard</option>
                </select>
              </div>
            )}
          </div>

          {/* Action Button */}
          <div className="max-w-4xl mx-auto">
            <button 
              onClick={handleGenerate} 
              className="w-full bg-slate-900 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-indigo-600 transition-all duration-300 shadow-lg hover:shadow-indigo-500/30 flex justify-center items-center gap-2 group"
            >
              ✨ Generate New Comprehension & Worksheet
            </button>
            
            {/* Status Message */}
            {message && (
              <p className="text-center text-[10px] sm:text-sm font-bold text-indigo-500 animate-pulse mt-3 sm:mt-4">
                {message}
              </p>
            )}
          </div>

          {/* Preview & Download Section */}
          <div className="mt-6 sm:mt-10 pt-4 sm:pt-8 border-t border-slate-200 space-y-3 sm:space-5 max-w-4xl mx-auto">
            <div className="flex flex-row items-center justify-between">
              <label className="text-[13px] sm:text-lg font-bold text-slate-800">Live Preview</label>
            </div>
            
            <textarea 
              className="w-full bg-white text-slate-900 font-mono text-[10px] sm:text-sm leading-tight sm:leading-relaxed p-3 sm:p-5 rounded-lg sm:rounded-2xl border-2 border-slate-200 outline-none h-48 sm:h-96 resize-y focus:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 transition-all custom-scrollbar" 
              value={aiResult} 
              readOnly 
            />

            {aiResult && (
              <div className="animate-in fade-in slide-in-from-bottom-2 duration-300">
                <button 
                  onClick={handleDownload} 
                  className="w-full bg-white border-2 border-slate-200 text-slate-700 p-2.5 sm:p-4 rounded-lg sm:rounded-xl font-bold text-[11px] sm:text-base hover:bg-slate-50 hover:border-slate-300 transition-all shadow-sm flex items-center justify-center gap-2"
                >
                  📥 Download PDF
                </button>
              </div>
            )}
          </div>

          <footer className="mt-8 sm:mt-14 text-center text-slate-400 text-[9px] sm:text-xs font-medium">
            © {new Date().getFullYear()} Eascode All Rights Reserved.
          </footer>
        </div>
      </div>
    </>
  );
}

export default ComprehensionTool;
